<template>
  <div class="logout-container">
    <VjButton :icon="IconNames.LOGOUT" @click="handleLogout" class="logout-btn" />
  </div>
</template>

<script setup lang="ts">
import { IconNames, useDialog } from '@vanjana/vue-ui';

type Emits = {
  (e: 'logout'): void;
};

const emit = defineEmits<Emits>();
const dialogService = useDialog();

const handleLogout = async () => {
  const result = await dialogService.confirm({
    title: 'Abmelden?',
    message: 'Sie werden abgemeldet und Ihr Upscaler-Key wird gelöscht.',
    confirmText: 'Ja, abmelden',
    cancelText: 'Nein, bleiben',
  });

  if (result) {
    emit('logout');
  }
};
</script>

<style scoped>
.logout-container {
  position: fixed;
  top: var(--space-m, 16px);
  right: var(--space-m, 16px);
  z-index: 100;

  .logout-btn {
    border: solid 1px #aaaaaa;
  }
}
</style>
